import { render, staticRenderFns } from "./footer-block.vue?vue&type=template&id=15c9d11a&scoped=true&lang=pug&"
import script from "./footer-block.vue?vue&type=script&lang=js&"
export * from "./footer-block.vue?vue&type=script&lang=js&"
import style0 from "./footer-block.vue?vue&type=style&index=0&id=15c9d11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9d11a",
  null
  
)

export default component.exports